// This file contains configuration values that are replaced by the pipeline
// DO NOT use import.meta.env here - these are plain string constants that get token-replaced
export const CONFIG = {
  baseUrl: 'https://cards.ampol.com.au/',
  apiBaseUrl: 'https://dig-api.ampol.com.au/',
  apimBaseUrl: 'https://dig-api.ampol.com.au/',
  apimKey: 'c88b98fdf8d943be88d881a46897f0b2',

  b2c: {
    instance: 'https://id.ampol.com.au/',
    tenant: 'id.ampol.com.au',
    signInPolicy: 'b2c_1a_v2_connect_sign_up_sign_in',
    resetPolicy: 'B2C_1A_V2_LOCAL_ACCOUNT_PASSWORD_CHANGE',
    forgotPasswordPolicy: 'TBD',
    appId: 'ec26102f-942c-47f4-afd9-93ac97e07dc7',
    scopes: 'https://caltexb2ctest01.onmicrosoft.com/api/user_impersonation',
  },

  mockEnabled: 'off',

  payment: {
    registerCardUrl: 'https://pay.ampol.com.au/home/registercard',
    registerDDAuthUrl: 'https://assets.contentstack.io/v3/assets/blt35cb056c1c8431c3/blt5a368650773e2846/688c39bcd86ce13f7f4ba06b/Ampol_Direct_Debit_Authorisation_Form_v3.pdf',
    cardPaymentUrl: 'https://pay.ampol.com.au/home/submitpayment',
  },

  adminRoleId: 'dac2b79d-6377-4a9b-b3e8-afe717ee6225',
  isAdminPortal: 'false',
  cashSupportEmail: 'ampolcash@ampol.com.au',
  isAmpolCashEnabled: 'true',
  customerServicePhone: '1300 365 096',
  notificationIntervalMinutes: '15',
  applicationInsights: 'InstrumentationKey=45c76e5c-78f4-490e-b396-6357ea8ff3fc;IngestionEndpoint=https://australiaeast-1.in.applicationinsights.azure.com/;LiveEndpoint=https://australiaeast.livediagnostics.monitor.azure.com/;ApplicationId=0512d7cd-f566-47a6-91bf-98115f0ec99d',
  enableNewCardModals: 'true',
  zonkaEnabled: 'true',
  evWay4Enabled: 'true',
  cardLimitsReadOnly: 'true',
};
